module.exports = "<form name=\"form\">\n  <my-input ng-model=\"currentPassword\"\n    my-options=\"fieldsOptions.password\"\n    enable-validator=\"true\">\n  </my-input>\n\n  <my-new-password my-id=\"password\"\n    my-password=\"newPassword\"\n    my-required=\"true\">\n  </my-new-password>\n\n  <div class=\"section center\">\n    <my-button my-label=\"$root.labels.edit\"\n      my-icon=\"$root.icons.edit\"\n      my-click=\"changePassword(currentPassword, newPassword)\"\n      my-disabled=\"form.$invalid\">\n    </my-button>\n  </div>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/account/directives/myChangePasswordForm.html
// module id = 798
// module chunks = 0